import type { IconSvgObject } from './types';

const Summation01Icon: IconSvgObject = [
  ["path", { d: "M19 6.5V3H5L13 12L5 21H19V17.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Summation01Icon;
